import BaseEvent from "../BaseEvent";

export default class AfterCheckoutError extends BaseEvent {
    responseBody: any;
    customMessage: string | null;

    constructor(responseBody: any, customMessage: string = null) {
        super();

        this.responseBody = responseBody;
        this.customMessage = customMessage;
    }
}
